// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"6806ead7","977":"8a7f4938"}[chunkId] + ".chunk.js";
};